import React, {useEffect, useState} from "react";
import {UnFullscreenIcon} from "../assets/icons/unFullscreenIcon";
import {FullscreenIcon} from "../assets/icons/FullscreenIcon";

const UseFullscreen = (divId: string, fullScreenIconSize = 18, fullScreenIconColor = "#1575fb") => {
    const [isFullScreen, setIsFullScreen] = useState(false);

    const toggleFullScreen = () => {
        if(!isFullScreen) {
            const container = document.getElementById(divId);
            if (!container) return;
            if (container.requestFullscreen) {
                container.requestFullscreen().catch((err) => {
                    console.error(`Error attempting to enter full-screen mode: ${err.message} (${err.name})`);
                });
                // @ts-ignore: Ignore TypeScript error for vendor-prefixed method
            } else if (container.webkitRequestFullscreen) {
                // @ts-ignore: Ignore TypeScript error for vendor-prefixed method
                container.webkitRequestFullscreen();
                // @ts-ignore: Ignore TypeScript error for vendor-prefixed method
            } else if (container.msRequestFullscreen) {
                // @ts-ignore: Ignore TypeScript error for vendor-prefixed method
                container.msRequestFullscreen();
            } else {
                alert('Fullscreen API is not supported in this browser.');
            }
        } else {
            if (document.fullscreenElement) {
                document.exitFullscreen().catch((err) => {
                    console.error(`Error while exiting full-screen mode: ${err.message}`);
                });
                // @ts-ignore: Ignore TypeScript error for vendor-prefixed method
            } else if (document.webkitFullscreenElement) { // Safari fallback
                (document as any).webkitExitFullscreen();
                // @ts-ignore: Ignore TypeScript error for vendor-prefixed method
            } else if (document.msFullscreenElement) { // IE/Edge fallback
                (document as any).msExitFullscreen();
            } else {
                console.log('Not in full-screen mode.');
            }
        }
    }

    const onFullScreenChange = () => {
        setIsFullScreen(!!document.fullscreenElement);
    }

    useEffect(() => {
        document.addEventListener('fullscreenchange', onFullScreenChange);
        document.addEventListener('webkitfullscreenchange', onFullScreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', onFullScreenChange);
            document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
        }
    }, []);

    const FullScreenIcon = () => {
        return isFullScreen ? <UnFullscreenIcon width={fullScreenIconSize} color={fullScreenIconColor} /> : <FullscreenIcon width={fullScreenIconSize} color={fullScreenIconColor} />;
    }

    return {
        toggleFullScreen,
        isFullScreen,
        FullScreenIcon
    }
}

export default UseFullscreen;